///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { Component, Input } from '@angular/core';
import { NgIf } from '@angular/common';

@Component({
    selector: 'winde-validation-message',
    imports: [NgIf],
    template: '<small *ngIf="message" class="d-block text-danger">{{message}}</small>'
})
export class GtthValidationMessageComponent {
    @Input() message: string;
}
